import { useCallback, useEffect } from 'react'
import { appUiStateFactory } from '~m/AppUi/context/context.ts'

export const useSetAppUiState =
  appUiStateFactory.useSetAppUiState

export const useScreenTitle = appUiStateFactory.useScreenTitle

export function useSetScreenTitle(title: string | null) {
  const setAppUiState = useSetAppUiState()
  useEffect(() => {
    setAppUiState({ screenTitle: title })
    return () => setAppUiState({ screenTitle: title })
  }, [setAppUiState, title])
}

export function useGlobalDialog() {
  const setAppUiState = useSetAppUiState()
  const globalDialog = appUiStateFactory.useGlobalDialog()
  return {
    isQuickSearchOpen: globalDialog === 'search',
    globalDialog,
    showGlobalDialog: (dialog: typeof globalDialog) => {
      setAppUiState({ globalDialog: dialog })
    },
  }
}

export function useActionsDrawer() {
  const setAppUiState = useSetAppUiState()
  const isOpen = appUiStateFactory.useActionsDrawerOpen()
  const setActionsDrawerOpen = useCallback(
    (open: boolean) => {
      setAppUiState({ actionsDrawerOpen: open })
    },
    [setAppUiState]
  )
  const openActionsDrawer = useCallback(
    () => setAppUiState({ actionsDrawerOpen: true }),
    [setAppUiState]
  )
  const closeActionsDrawer = useCallback(
    () => setAppUiState({ actionsDrawerOpen: false }),
    [setAppUiState]
  )
  return {
    isOpen,
    setActionsDrawerOpen,
    openActionsDrawer,
    closeActionsDrawer,
  }
}
